import { action } from 'satcheljs';
import { SmartTaskSuggestion } from 'owa-mail-store';
import { ClientItem } from 'owa-mail-store';

export default action(
    'cacheSmartTaskData',
    (item: ClientItem, validPropertyExists: boolean, smartTasks?: SmartTaskSuggestion[]) => {
        return {
            item: item,
            validPropertyExists: validPropertyExists,
            smartTasks: smartTasks,
        };
    }
);
